/* King Product Options sends shoppers to /cart after "Add to cart" unless a global
   ymqCart.slidOpen() exists. This opens the theme's own cart popup instead, so
   shoppers stay on the product and can keep shopping. If anything fails, it falls
   back to the cart page like before. */
(function () {
  if (window.ymqCart) return;

  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  window.ymqCart = {
    slidOpen: function () {
      var drawer = document.querySelector('cart-drawer');
      var notification = document.querySelector('cart-notification');
      var popup = drawer || notification;
      if (!popup || typeof popup.renderContents !== 'function') {
        throw new Error('No cart popup on this page'); // the app then goes to /cart
      }

      var sections = drawer
        ? 'cart-drawer,cart-icon-bubble'
        : 'cart-notification-product,cart-notification-button,cart-icon-bubble';

      Promise.all([
        fetch(cartUrl + '.js').then(function (r) { return r.json(); }),
        fetch(root + '?sections=' + sections).then(function (r) { return r.json(); }),
      ])
        .then(function (results) {
          var newest = results[0].items[0]; // Shopify lists the newest line first
          if (!newest) throw new Error('Cart is empty');
          popup.renderContents({ key: newest.key, id: newest.id, sections: results[1] });
        })
        .catch(function () {
          window.location.href = cartUrl;
        });
    },
  };
})();
